export default "__VITE_ASSET__Dfukz5vX__"